<template>
    <div class="reminditemWrapper">

      <el-page-header @back="goBack" :title="$t('remind.back')" :content='template_name'>
      </el-page-header>

      <div class="remind_mid_ctn" >
        <el-row >  
          <el-col :span="2" class="icon_ctn">
            <i class="el-icon-document-copy" style="font-size:60px"></i>
          </el-col>
          <el-col :span="22" class="current_template">
            <el-row >
              {{$t('remind.currentTemplate')}}:
            </el-row>

            <el-row>
              <el-col :span="20">
                <el-card shadow="hover" style="margin-bottom:20px;border-radius:10px 10px 10px 10px">
                  {{current_template}}<span style="font-size:14px" class="red">{{$t('remind.Bracket_tip')}}</span>
                </el-card>
              </el-col>
            </el-row>

          </el-col>
        </el-row>
      </div>



      <div class="remind_main_ctn">
        <el-row style="width:90%">
          <el-tabs type="border-card" >
            <el-tab-pane :label="$t('remind.templateChoose')">

              <el-row>
                <!-- 卡片左侧 -->
                <el-col :span="6">
                  <span style=""><b>{{$t('remind.currentSelectTemplate')}}</b><b class="red">({{$t('remind.testTemplate')}})</b></span>
                  <el-card shadow="always" style="margin-bottom:20px ;height:300px" class="top word card_border">
                    {{select_template}}
                  </el-card>
                  <el-row style="height:60px">
                    <el-input v-model="input" :placeholder="$t('remind.testPhoneNum_tip')"></el-input>
                  </el-row>
                  <el-row class="button" >
                    <el-button type="primary" plain @click="sendTestNote">{{$t('remind.sentTestMessage')}}</el-button>
                  </el-row>
                </el-col>
                <!-- 卡片右侧 -->
                <el-col :span="18" >
                  <div class="cart_right_ctn">
                    <div class="template_radio">
                      <b style="color:#909399">
                        {{$t('remind.systemTemplate')}}:
                      </b>

                      <div class="radio_ctn">
                        <el-radio  class="radio" style="margin-top:25px;margin-bottom:10px" v-for="item in system_template" :key="item.templateId" :label="item.templateId" v-model="radio1">
                            {{item.content}}
                        </el-radio>  
                      </div>

                      <el-divider></el-divider>
                          <b style="color:#909399">
                            {{$t('remind.customTemplate')}}:
                          </b>

                      <div class="radio_ctn" >
                        <el-radio  class="radio word" style="margin-top:25px;margin-bottom:10px;width:730px" v-for="item in custom_template" :key="item.templateId" :label="item.templateId" v-model="radio1">
                            {{item.content}}
                        </el-radio>  
                      </div>
                    </div>

                    <el-divider></el-divider>
                    <el-row style="font-size:14px" class="info">
                      <b>{{$t('remind.defaultLanguage_tip')}}</b>
                      <span class="red">({{$t('remind.customTemplateLanguage_tip')}})</span>
                    </el-row>

                    <el-row class="top">
                      <el-radio-group v-model="radio2" v-show="radio1==1||radio1==2||radio1==3">
                        <el-radio-button v-for="item,index in support_language" :key="item" :label="index">{{item}}</el-radio-button>
                      </el-radio-group>                      
                    </el-row>

                    <el-row >
                      <el-col class="button" style="margin-top:50px;margin-bottom:20px">
                        <el-button type="primary" @click="updateUserSelectionTemplate">{{$t('remind.saveSetting')}}</el-button>
                      </el-col>
                    </el-row>

                  </div>
                </el-col>
              </el-row>
            <!-- <el-button @click="demo">{{$t('other.a945')}}</el-button>   -->
            </el-tab-pane>

            <el-tab-pane :label="$t('remind.customTemplate')">
              <el-row>
                <!-- 左侧 -->
                <el-col :span="6">
                  <span style=""><b>{{$t('remind.currentSelectTemplate')}}</b><b class="red">({{$t('remind.testTemplate')}})</b></span>
                  <el-card shadow="always" style="margin-bottom:20px ; height:300px" class="top card_border">
                    {{select_template}}
                  </el-card>
                  <el-row style="height:60px">
                    <el-input v-model="input" :placeholder="$t('remind.sentTestMessage')"></el-input>
                  </el-row>
                  <el-row class="button" >
                    <el-button type="primary" plain @click="sendTestNote">{{$t('remind.sentTestMessage')}}</el-button>
                  </el-row>

                </el-col>
                <!-- 卡片右侧 -->
                  <el-col :span="18">
                    <div class="cart_right_ctn">
                      <!-- 标签 -->
                      <el-row>
                        <el-col :span="6">
                          <b style="font-size:14px" class="info">
                            {{$t('remind.insertLabel')}}
                          </b>
                          <span>
                            <el-tooltip class="item" effect="dark" :content="($t('remind.label_tip'))" placement="top">
                              <el-button type="text">({{$t('remind.what_label')}})</el-button>
                            </el-tooltip>
                          </span>
                        </el-col>
                        <el-col :span="18">
                            <el-button size="small" round class="tag" v-for="(item,index) in taglist" :key="index"  @click="insert(item);tagUpdateCharge()">{{item}}</el-button>
                            <!-- <el-button size="small" round class="tag" @click="demo">{{$t('other.a945')}}</el-button> -->
                        </el-col>
                      </el-row>

                      <!-- 输入框 -->
                      <el-row>
                        <el-col>
                          <el-input type="textarea" :rows="7" v-model="content" id="textarea" autocomplete="off" ref="singleText" style="margin:20px 0px 20px 0px" @keyup.native="onkeyup($event)"></el-input>  
                        </el-col>
                      </el-row>




                      <el-row>
                        <el-col :span="14">
                          <el-row style="font-size:14px;margin:5px 0px 5px 0px" class="info">
                            {{$t('remind.haveInput')}}{{content.length}}{{$t('remind.character')}}。 {{$t('remind.CountNum')}}： {{count}} ({{$t('remind.countCharacterTip')}})
                          </el-row>
                          <el-row style="font-size:12px" class="red">
                            {{$t('remind.customTemplateLanguage_tip')}}
                          </el-row>

                        </el-col>

                        <el-col :span="5">
                            <el-popover
                            placement="top"
                            width="500"
                            trigger="hover"
                            ref="dcPopover"
                            >
                            <span style="font-size:16px">{{$t('remind.limitLengthTip')}}</span>
                            <div style="font-size:16px" class="red">({{$t('remind.messageChargeTip')}})</div>
                            <el-table
                            :data="tableData"
                            :span-method="objectSpanMethod"
                            border>
                            <el-table-column
                              prop="messageCount"
                              :label="$t('remind.messageCount')"
                              width="180">
                            </el-table-column>
                            <el-table-column
                              prop="messageType"
                              :label="$t('remind.messageType')">
                            </el-table-column>
                            <el-table-column
                              prop="chargeCountStandard"
                              :label="$t('remind.chargeCountStandard')">
                            </el-table-column>
                          </el-table>
                            <el-button slot="reference" type="danger" plain>{{$t('remind.chargeStandard')}}</el-button>  
                          </el-popover>
                        </el-col> 
                        <el-col :span="5">
                          <el-button @click="savetemplate" type="primary">{{$t('remind.addTemplate')}}</el-button>
                        </el-col>
                      </el-row>

                        <el-divider></el-divider>

                        <el-row v-for="(item,index)  in custom_template" :key="index"  class="info">

                          <el-row>
                            <el-col :span="22" style="padding-right:20px;font-size:14px;width:730px" class="word">
                              {{item.content}}
                            </el-col>
                            <el-col :span="2">
                              <el-button  icon="el-icon-delete" @click="deletetemplate(item.templateId,index)"></el-button>
                            </el-col>
                          </el-row>

                          <el-divider></el-divider>
                          </el-row>
                    </div>
                  </el-col>
              </el-row>
            </el-tab-pane>

          </el-tabs>
        </el-row>

      </div>

      <el-divider></el-divider>

      <div class="remind_bottom" >
        <el-row style="width:90%;height:70px">

          <!-- 左侧 -->
          <el-col :span="6">
            <el-row class="icon_center">
              <el-col :span="9">
                <i class="el-icon-warning-outline red" style="font-size:40px;display:flex;justify-content: center;"></i>
              </el-col>
              <el-col :span="15" style="display:flex;align-items:center;height:40px">
                <b class="info">{{$t('remind.sendCondition')}}</b>
              </el-col>
            </el-row>
          </el-col>

          <!-- 右侧 -->
          <el-col :span="18" style="padding-left:30px ;border-left: 2px solid #eeee;">
            <el-row v-for="(item,index) in condition" :key="index" style="font-size:14px" class="info">
              {{index+1}}.{{item}}
            </el-row>
          </el-col>
        </el-row>
      </div>



    </div>

</template>
    
    <script>
    import api from '../../api/moudles/remind'
    import { mapState, mapMutations } from 'vuex'
    import test from '../../pages/remind/test.json'
    export default {
    data(){
    return{

        template_name:this.$route.params.template_name,
        shopId:this.$route.params.shopId,
        noteType:this.$route.params.noteType,

        radio1:false,
        radio2:0,  
        charge:test.charge,

        support_language:[this.$t('remind.English'),this.$t('remind.Chinese'),this.$t('remind.My'),this.$t('remind.Th')],
        condition:null,
        taglist:["<#"+this.$t('remind.recipientName')+"#>","<#"+this.$t('remind.OrderId')+"#>","<#"+this.$t('remind.shopName')+"#>","<#"+this.$t('remind.purchaseDate')+"#>"],
        tableData:test.tableData,

        content:"",
        language_value:"true",
        input:"",

        content1:'',
        system_template:null,
        custom_template:'',
        count:0,
        lastTimeStamp: 0,//标记当前事件函数的时间戳
        current_template:'',
        select_template:null,
        tableData:[{
          messageCount:"x<=70",
          messageType:this.$t('remind.messageType'),
          chargeCountStandard:'160'+this.$t('remind.messageType_tip2')
        },{
          messageCount:"x<=70",
          messageType:this.$t('remind.messageType'),
          chargeCountStandard:'70'+this.$t('remind.messageType_tip2')
        },{
          messageCount:"70<x<=536",
          messageType:this.$t('remind.messageType'),
          chargeCountStandard:'160'+this.$t('remind.messageType_tip2')
        },{
          messageCount:"70<x<=536",
          messageType:this.$t('remind.messageType'),
          chargeCountStandard:'67'+this.$t('remind.messageType_tip2')
        }]















        }


    },
    
    computed:{
        ...mapState({
            userId: state => state.shopaccess.userInfo.userId,
            lazadashopinfo: state=>state.shopaccess.lazadashopinfo,
			      shopList: state => state.shopaccess.shopInfo || '',
        }),
    },
    
    watch:{
      radio1(){
          // var index = this.support_language.map(item => item).indexOf(this.radio2)
          // var language = test.support_language_index[index]
          // var shopId = this.shopId
          var templateId = this.radio1
          if(templateId==1||templateId==2||templateId==3){
            var queryData = this.system_template.filter(function(fp) {
              return fp.templateId == templateId
            })
          }else{
            var queryData = this.custom_template.filter(function(fp) {
              return fp.templateId == templateId
            })
          }
          console.log(queryData)
          this.select_template = queryData[0].content
        // this.select_template = 
      },

      radio2(){
          var support_language = ["EN","ZH","MY","TH"]
          var language =  support_language[this.radio2]
          api.getSystemTemplate({
            language :language,
            noteType :this.noteType,
            shopId :this.shopId
          })
            .then(res => {
              console.log(res)
              this.system_template = res.shopTemplates
              var that = this 
              try{
                var queryData1 = res.shopTemplates.filter(function(fp) {
                  return fp.content == that.current_template
                })
                console.log(queryData1)
                this.radio1 = queryData1[0].templateId    
              }catch(err){
                console.log(err)
              }
          })
      }




    },

    mounted(){
      this.getPageData()
      this.setCondition()
    },
    methods:{
        setCondition(){
          var condition = [[this.$t('remind.paymentRemind_tip1'),this.$t('remind.paymentRemind_tip2'),this.$t('remind.paymentRemind_tip3')],[this.$t('remind.shipRemind_tip1'),this.$t('remind.shipRemind_tip2'),this.$t('remind.signRemind_tip1')]]

          switch (this.template_name) {
            case this.$t('remind.paymentRemind'):
              this.condition = condition[0]
              break;
            case this.$t('remind.shipReminder'):
              this.condition = condition[1]
              break
            case this.$t('remind.signRemind'):
              this.condition = condition[2]
              break
            default:
              break;
          }

        },

        //获取页面初始数据
        async getPageData(){
          let params = {
            shopId:this.shopId,
            noteType :this.noteType
          }   
          // 获取选择的模板
          await api.getShopChooseTemplate(params)
          .then(res => {
            console.log(res)
            this.current_template = res.template
            this.select_template = res.template
          })     
          

          // 获取自定义短信模板列表(成功;shopid必须是shopee商店中的)
          api.getCustomTemplateList(params)
            .then(res => {
              var that = this 
              this.custom_template = res.noteTemplates
              try{
                var queryData2 = res.noteTemplates.filter(function(fp) {
                  return fp.content == that.current_template
                })         
                this.radio1 = queryData2[0].templateId    
              }catch(err){
                console.log(err)
            }                 
          })
            
          // 获取系统模板(成功，不需要加language;shopId必须是shopee商店的)
          api.getSystemTemplate({
            noteType :this.noteType,
            shopId :this.shopId
          })
            .then(res => {
              console.log(res)
              this.system_template = res.shopTemplates
              var that = this 
              var index = test.support_language_index.indexOf(res.language)
              if(res.language==null||res.language=='NONE'){
                this.radio2 = test.support_language[0]
              }else{
                this.radio2 = test.support_language[index]
              }
              
              try{
                var queryData1 = res.shopTemplates.filter(function(fp) {
                  return fp.content == that.current_template
                })
                console.log(queryData1)
                this.radio1 = queryData1[0].templateId    
              }catch(err){
                console.log(err)
              }
          })
        },
        // 返回短信通道开关页面
        goBack:function(){
            this.$router.push({
              name:"remind",
              params:{
                shopId:this.shopId
              }
            })
        },
        // 获取光标位置，并插入标签
        async insert(name) {
          var myValue = name 
          const myField = this.$refs.singleText.$el.querySelector('textarea');
          if (myField.selectionStart || myField.selectionStart === 0) {
            var startPos = myField.selectionStart
            var endPos = myField.selectionEnd
            this.content = myField.value.substring(0, startPos) + myValue 
            + myField.value.substring(endPos, myField.value.length)
            await this.$nextTick() 
            myField.focus()
            myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
            } else {
            this.content += myValue
          }
        },    


        // 模板选择
        updateUserSelectionTemplate:function(){ 
          var index = this.support_language.map(item => item).indexOf(this.radio2)
          var language = test.support_language_index[index]
          var shopId = this.shopId
          var templateId = this.radio1
          console.log(templateId)
          console.log(typeof(templateId))
          if(templateId==1||templateId==2||templateId==3){
            var templateType = 0
            var queryData = this.system_template.filter(function(fp) {
              return fp.templateId == templateId
            })
          }else{
            var templateType = 1
            var queryData = this.custom_template.filter(function(fp) {
              return fp.templateId == templateId
            })
          }
          if(templateId==false){
              this.$alert(this.$t('remind.selectTemplate'),this.$t('remind.failSaveTemplate'), {
                confirmButtonText: this.$t('remind.confirmButtonText'),
                callback: action => {
                }
              })
          }else{
            api.updateUserSelectionTemplate({
              language:language,
              noteType:this.noteType,
              shopId:shopId,
              templateId:templateId,
              templateType:templateType,
            })
              .then(res => {
                if(res==undefined){
                  
                }else{
                  this.current_template = queryData[0].content
                }

            })
          }

        },


      // 保存自定义模板(success)
        savetemplate:function(){
          var content = this.content
          var shopId = this.shopId
          var noteType = this.noteType
          console.log(content.length)
          if(content==''){
            this.$alert(this.$t('remind.inputeContent'),this.$t('remind.addCustomFail'), {
              confirmButtonText: this.$t('remind.confirmButtonText'),
              callback: action => {
              }
            })
          }else if(content.length>=536){
            this.$alert(this.$t('remind.addCustomFail'),this.$t('remind.addCustomFail'), {
              confirmButtonText: this.$t('remind.confirmButtonText'),
              callback: action => {
              }
            })            
          }
          else{
          // 添加短信模板
              api.addCustomMessageTemplate({
                content:content,
                shopId:shopId,
                noteType :noteType
              })
              .then(res => {
                console.log(res)
                api.getCustomTemplateList({
                  shopId:shopId,
                  noteType:noteType
                })
                  .then(res => {
                    console.log(res)
                    this.custom_template = res.noteTemplates            
                })
                this.content = ''
              })
              }

        },

        // 删除模板
        deletetemplate(templateId,index) {
          this.$confirm(this.$t('remind.confirmDeleteCustom'),this.$t('remind.tip'), {
            confirmButtonText:this.$t('remind.confirmButtonText'),
            cancelButtonText:this.$t('remind.cancel'),
            type: 'warning'
          }).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('remind.successDelete')
            });
            //  删除自定义短信模板(成功)
              api.deleteCustomMessageTemplate({
                templateId:templateId,
              })
              .then(res => {
                console.log(res)
              })

            var template_ = this.custom_template
            template_.splice(index,1)

          }).catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('remind.haveCancelDelete')
            });          
          });
        },


        // 标签添加时计算收费
        tagUpdateCharge(){
          api.getNoteCustomTemplateCount({
            noteContent :this.content,
          })
          .then(res => {
            this.count = res.count
          })
        },



        // 用户停止输入时计算
        onkeyup(event){
          if(event.keyCode != 13){//除回车键外
            //标记当前事件函数的时间戳
            this.lastTimeStamp = event.timeStamp;
            setTimeout(() => {
            //1s后比较二者是否还相同（因为只要还有事件触发，lastTimeStamp就会被改写，不再是当前事件函数的时间戳）
              if(this.lastTimeStamp == event.timeStamp){
                console.log('发送请求');
                api.getNoteCustomTemplateCount({
                  noteContent :this.content,
                })
                .then(res => {
                  this.count = res.count
                })               
              }
            }, 300);
          }
        }, 
        
        demo(){



        },


        // 发送测试短信
        // 泰国的手机号码有10位数。都是以0开头的。
        // 马来西亚的手机号码一般都是13位数字。0060 1X XXXXXXX
        sendTestNote(){
          if(this.current_template!=''&&this.input.length>=10&&this.input.slice(0,1)==0&&(this.input.length==10||this.input.length==13)){
            api.sendNoteTest({
              noteContent :this.select_template,
              phoneNumber :this.input 
              })
            .then(res => {
              if(res.code=='ok'){
                this.$message({
                  message: this.$t('remind.haveSendTestMessage'),
                  type: 'success'
              });
            }else{
              this.$message.error(this.$t('remind.failSendTestMessage'));
            }
          })    

          }else{
            this.$message.error(this.$t('remind.phoneFormatErr'));
          }          
        },

        // 表格合并单元格
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
          if (columnIndex === 0) {
            if (rowIndex % 2 === 0) {
              return {
                rowspan: 2,
                colspan: 1
              };
            } else {
              return {
                rowspan: 0,
                colspan: 0
              }
            }
          }
          this.$refs.dcPopover.updatePopper()

        },



        //websock链接
        connectWebsocket(){
            const wsuri = "ws://47.57.9.89:8101/ws";
            this.websock = new WebSocket(wsuri);
            console.log(this.websock)
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
    
        },
         websocketonopen(){ //连接建立之后执行send方法发送数据
           this.$message.success(this.$t('other.a371'))
            
          },
          websocketonerror(){//连接建立失败重连
            this.$message.success(this.$t('other.a372'))
          },
          websocketonmessage(e){ //数据接收
            const redata = JSON.parse(e.data);
            console.log('字符串',redata)
          },
          websocketsend(Data){//数据发送
            this.websock.send(Data);
          },
          websocketclose(e){  //关闭
            console.log('断开连接',e);
          },
    
    }
    }
    
    </script>
    <style lang="scss" scoped>
    @import "~@assets/scss/mixins";
    .reminditemWrapper{
          // @include main-right-content();
    
    
          .remind_item_header{
              height: 30px;
              border-bottom: 1px solid #eeee;
              padding: 10px 0;
    
              .merber{
                  margin-left:20px
              }
          }

          .remind_mid_ctn{
            margin-top:  20px;
            border-bottom: 1px solid #eeee;
          }
          .icon_ctn{
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .remind_main_ctn , .remind_bottom{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
            margin-bottom:40px
          }
          .template_radio{
            width: 100%;
            display: flex;
            flex-direction: column;
          }
          .radio{
            width: 85%;
            white-space:normal  

          }
          .radio_ctn{
            margin-top: 20px;
            margin-bottom: 20px;
          }
          .cart_right_ctn{
            margin-left: 30px;
          }
          .button , .button_preserve_ctn{
            display: flex;
            justify-content: center;
          }

          .icon_center{
            display: flex;
            justify-items: center;
            align-items: center;
            height: 50px;
          }
          .tag{
            margin-top: 3px;
          }
          .center{
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .top{
            margin-top: 20px;
          }
          .red{
            color:#F56C6C
          }
          .info{
            color:#606266
          }
          .word{
            word-wrap: break-word;
          }
          .card_border{
            border-radius:0px 60px 60px 60px
          }
    }
    
    </style>